import { useFormContext, Controller, FieldValues, Path } from 'react-hook-form';
import { useDeliveryContext } from '@features/delivery/components/DeliveryModal/DeliveryContext';
import { FieldWrapper } from '../FieldWrapper';
import { DeliveryEmailInput } from '@features/delivery/components/DeliveryEmailInput';
import { EmailTagsInputConfig } from '@features/dynamicForm/types';
import { DeliveryItem } from '@features/delivery/types';

export const EmailTagsField = <TFormValues extends FieldValues>({
    config,
}: {
    config: EmailTagsInputConfig<TFormValues>;
}) => {
    const { control } = useFormContext<TFormValues>();

    const { suggestedEmails } = useDeliveryContext<DeliveryItem, unknown>() as {
        suggestedEmails?: string[];
    };

    return (
        <FieldWrapper config={config}>
            <Controller
                name={config.name as Path<TFormValues>}
                control={control}
                rules={config.validation}
                render={({ field }) => (
                    <DeliveryEmailInput
                        emails={field.value || []}
                        onEmailsChange={field.onChange}
                        placeholder={config.placeholder || ''}
                        suggestedEmails={suggestedEmails || []}
                    />
                )}
            />
        </FieldWrapper>
    );
};
